import { AbgSxProps } from '@abg/typings';

export const navTabsWrapper: AbgSxProps = (theme) => ({
  background: theme.palette.background.primary,
  boxShadow: '0px 4px 12px 0px #0000001A',
  borderRadius: theme.borderRadius.largeCard + 'px',
  padding: '8px',
});

export const horizontalSubnavList: AbgSxProps = { gap: '8px' };

export const horizontalSubnavTab: AbgSxProps = (theme) => ({
  textTransform: 'capitalize',
  padding: '16px 24px',
  borderRadius: `${theme.borderRadius.mediumCard}px`,
  color: theme.palette.text.primary,
  minWidth: '80px',
  '&:hover': {
    backgroundColor: theme.palette.action.selected,
    color: theme.palette.text.primaryInverse,
  },
  '&.Mui-selected': {
    backgroundColor: theme.palette.action.selected,
    color: theme.palette.text.primaryInverse,
  },
});

export const HorizontalSubnavText: AbgSxProps = {
  lineHeight: { xs: '13px', sm: '15px' },
  fontWeight: 700,
};
